import $ from 'jquery';
import pako from 'pako';

import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

// Função helper para decodificar respostas base64+gzip com validação
const decodeTwoFactorResponse = (data) => {
  if (data == null) return data;
  if (typeof data === 'object') return data;
  
  // Verifica se é uma string válida para base64
  if (typeof data !== 'string') return data;
  
  // Tratamento específico para erro de autenticação do backend
  if (data === 'erro_auth') {
    console.error('❌ Erro de autenticação: Token ausente ou inválido');
    return { error: true, message: 'Sessão expirada ou inválida', code: 'AUTH_ERROR' };
  }
  
  // Remove espaços em branco e quebras de linha
  const cleanData = data.trim().replace(/\s+/g, '');
  
  // Verifica se contém apenas caracteres válidos para base64
  const base64Regex = /^[A-Za-z0-9+/]+=*$/;
  if (!base64Regex.test(cleanData)) {
    console.warn('⚠️ Payload não está em formato base64 válido:', data);
    // Se for uma mensagem de erro conhecida, retorna formatada
    if (data.includes('erro') || data.includes('error')) {
      return { error: true, message: data };
    }
    return data;
  }
  
  try {
    const binaryString = atob(data);
    const binary = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
    const decompressed = pako.ungzip(binary, { to: 'string' });
    return JSON.parse(decompressed);
  } catch (error) {
    console.warn('⚠️ Erro ao decodificar payload:', error.message);
    // Em caso de erro, tenta retornar como JSON se possível
    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  }
};

// Função helper para tratar erros de Ajax
const handleAjaxError = (xhr, status, error) => {
  const errorData = decodeTwoFactorResponse(xhr.responseText);
  
  // Se for erro de autenticação
  if (errorData?.code === 'AUTH_ERROR') {
    console.error('❌ Sessão expirada - redirecionando para login');
    // Limpa storage e redireciona
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/auth/login';
    return [401, errorData];
  }
  
  // Outros erros
  return [400, errorData || { message: xhr.responseText || 'Dados não localizados' }];
};

const RestTwoFactorGet = (config) => {
};

const RestTwoFactorPost = (config) => {
  
  if (!config || !config.data) {
    console.error('🔐 RestTwoFactorPost - config.data está undefined!');
    return Promise.reject([400, { message: 'Dados inválidos' }]);
  }
  
  const Arr_ = JSON.parse(config.data);
    const caminho = Arr_.dest.trim();
    const token = sessionStorage.getItem('ddesp') ? JSON.parse(base64_decode(sessionStorage.getItem('ddesp')))?.[14] : '';
  
  // Para verifyMfaChallenge, não temos sessionStorage ainda (usuário não logou completamente)
  if (caminho === 'verifyMfaChallenge') {
    return new Promise(function (resolve, reject) {
      try {
        const payload = JSON.stringify({
          dest: 'verifyMfaChallenge',
          tempToken: Arr_.dataPost.tempToken,
          code: Arr_.dataPost.code,
          trustDevice: Arr_.dataPost.trustDevice ? 1 : 0,
          deviceFingerprint: Arr_.dataPost.deviceFingerprint
        });
        
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/twofactor.php`,
          type: 'POST',
          contentType: 'application/json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          dataType: 'text', // Recebe como texto para descomprimir manualmente
          data: payload,
          success: function (data, status, xhr) {
           
            try {
              const jsonParsed = decodeTwoFactorResponse(data);
             
              resolve([200, jsonParsed]);
            } catch (e) {
             
              reject([500, {message: 'Erro ao processar resposta'}]);
            }
          },
          error: function (xhr, status, error) {
            console.error('🔐 MFA error:', xhr.responseText);
            try {
              const jsonParsed = decodeTwoFactorResponse(xhr.responseText);
              
              reject([400, jsonParsed]);
            } catch (e) {
              reject([400, {message: 'Código inválido'}]);
            }
          },
        });
      } catch (err) {
        console.error('🔐 Exception:', err);
        reject([500, { message: 'Server Error' }]);
      }
    });
  }
  
  // Para outros endpoints, usa sessionStorage normalmente
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];


  // Verifica se o token existe antes de prosseguir
  if (!token || token === '') {
  
    return Promise.reject([401, { 
      error: true, 
      message: 'Sessão expirada ou inválida. Faça login novamente.',
      code: 'NO_TOKEN' 
    }]);
  }

if (caminho === 'configNewTwoFactor'){
        return new Promise(function (resolve, reject) {
       
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                     //       'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('configNewTwoFactor'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        if (jsonParsed?.code === 'AUTH_ERROR') {
                            reject([401, jsonParsed]);
                            return;
                        }
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        const errorResponse = handleAjaxError(xhr, status, error);
                        reject(errorResponse);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'checkValidCode'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                      //      'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('checkValidCode'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'checkCode'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                      //      'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('checkCode'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'statusTwoFactor'){
         return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('statusTwoFactor'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
    
                        const jsonParsed = decodeTwoFactorResponse(data);

                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        const errorResponse = handleAjaxError(xhr, status, error);
                        reject(errorResponse);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'disableTwoFactor'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));
                const stepUpToken = Arr_.stepUpToken ?? '';

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                     //       'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('disableTwoFactor'),
                            dd: dataPost,
                            stepUpToken,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'enableTwoFactor'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));
                const stepUpToken = Arr_.stepUpToken ?? '';

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                      //      'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('enableTwoFactor'),
                            dd: dataPost,
                            stepUpToken,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        
                        // Remove flag de MFA obrigatório após configuração bem-sucedida
                        if (jsonParsed && jsonParsed.success) {
                            localStorage.removeItem('require_mfa_setup');
                            sessionStorage.removeItem('require_mfa_setup');
                           
                        }
                        
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'commandBlockTwoFactor'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                     //       'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('commandBlockTwoFactor'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'commandUnBlockTwoFactor'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                       //     'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('commandUnBlockTwoFactor'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'statusBlockTwoFactor'){
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                       //     'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('statusBlockTwoFactor'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'getMfaObrigatorio'){
        // Busca o status atual de MFA obrigatório para a conta (tabela clientes.mfa_obrigatorio)
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                        //    'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('getMfaObrigatorio'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } else if (caminho === 'setMfaObrigatorio'){
        // Atualiza o status de MFA obrigatório para a conta (tabela clientes.mfa_obrigatorio)
        return new Promise(function (resolve, reject) {
            try {
                const compressed = pako.gzip(JSON.stringify(Arr_.dataPost));
                const dataPost = btoa(String.fromCharCode(...compressed));

                $.ajax({
                    url: `${ENDERECO_API}src/api/controller/espiaoCtrl_.class.php`,
                    type: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                         //   'Content-Encoding': 'gzip',
                        },
                    data: {
                            pp: base64_encode('autenticacoes'),
                            ll: base64_encode('setMfaObrigatorio'),
                            dd: dataPost,
                    },
                    success: async function (data, status, xhr) {
                        const jsonParsed = decodeTwoFactorResponse(data);
                        resolve([200, jsonParsed]);
                    },
                    error: function (xhr, status, error) {
                        reject([400, { message: 'Dados não localizados' }]);
                    },
                });
            } catch (err) {
                reject([500, { message: 'Server Error' }]);
            }
        });
    } 






    

//



};
export {RestTwoFactorGet, RestTwoFactorPost};



